import React, { useState } from "react";
import axios from "axios";

function NewsLetterArea(props) {

    const API_URL = `${process.env.REACT_APP_API_FOLDER}subscribe_confirm/${props.item_id}`;
    const API_TOKEN = process.env.REACT_APP_API_TOKEN;

    const [responseMessage, setResponseMessage] = useState(null);
    const [loading, setLoading] = useState(false);

    React.useEffect(() => {
        setLoading(true);
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const { data } = await axios.get(API_URL, {
                headers: { "X-API-TOKEN": API_TOKEN }
            });

            // Check if the response is as expected
            setResponseMessage(String(data));

        } catch (err) {
            console.error("Error during API call:", err);
            setResponseMessage(
                "Sorry, something went wrong. Please try again later."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="newsletter-wrapper">
            <div className="container">
                <div className="row align-items-center">
                    {/* ---------------------- LEFT SIDE ---------------------- */}
                    <div className="col-lg-6">
                        <div className="newsletter-side text-center text-lg-start mx-auto mx-lg-0">
                            <h2>Stay up to date</h2>
                            <p>
                                New workshops and opportunities go out to our mailing list first!
                                Enter your email here, and we&apos;ll keep you up to date with
                                news, workshops and opportunities at CAMP.
                            </p>

                            {responseMessage ? (
                                <p className="newsletter-response">{responseMessage}</p>
                            ) : (
                                <p className="newsletter-response">Confirming your subscription...</p>
                            )}
                        </div>
                    </div>

                    {/* ---------------------- RIGHT SIDE ---------------------- */}
                    <div className="col-lg-6 ">
                        <div className="achievement-counter-side">
                            <div className="row g-4">
                                <div className="col-lg-6  col-md-6">
                                    <div className="achievement-box-style-one">
                                        <div className="achievement-icon">
                                            <i className="fa-solid fa-tower-cell fa-2xl"></i>
                                        </div>
                                        <div className="achievement-box-content">
                                            <h4>Workshop news</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6  col-md-6">
                                    <div className="achievement-box-style-one">
                                        <div className="achievement-icon">
                                            <i className="fa-solid fa-door-open fa-2xl"></i>
                                        </div>
                                        <div className="achievement-box-content">
                                            <h4>Opportunities</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6  col-md-6">
                                    <div className="achievement-box-style-one">
                                        <div className="achievement-icon">
                                            <i className="fa-solid fa-tag fa-2xl"></i>
                                        </div>
                                        <div className="achievement-box-content">
                                            <h4>Discount offers</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6  col-md-6">
                                    <div className="achievement-box-style-one">
                                        <div className="achievement-icon">
                                            <i className="fa-solid fa-bolt fa-2xl"></i>
                                        </div>
                                        <div className="achievement-box-content">
                                            <h4>Exciting updates</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NewsLetterArea;
